<template>
  <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <strong>{{ $t("finance.invoiceNumberLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.companyTypeLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.companyNameLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.mandateStatusLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.mandateCreatedLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.productLabel") }}</strong>
          </td>
          <td cvalign="middle">
            <strong>{{ $t("finance.seeDetailsLabel") }}</strong>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.invoices === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(invoice, index) in invoices">
          <tr
            :key="index"
            class="trhover parent"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            <td valign="middle">
              {{ invoice.invoice }}
            </td>
            <td valign="priority-1">
              {{ $t('finance.companyType_' + invoice.customer.type) }}
            </td>
            <td valign="priority-1">
              {{ invoice.customer.name }}
            </td>
            <td valign="priority-1">
              {{ $t('finance.invoiceStatus_' + invoice.status) }}
            </td>
            <td valign="middle" class="priority-1">
              {{ displayDateTimestamp(invoice.created) }}
            </td>
            <td valign="priority-1">
              {{ $t('finance.product_' + invoice.customer.product) }}
            </td>
            <td valign="middle">
                  <a
                    class="see-more cursor-pointer"
                    @click="getInvoiceDetails(invoice)"
                  >
                    <font-awesome-icon
                      icon="arrow-alt-circle-right"
                      size="2x"
                    />
                  </a>
                  </td>
          </tr>
          
        </template>
      </tbody>
    </table>
    <div id="modal_popup_details" class="modal-popup">
      <div class="modal-popup-content">
        <a
          onclick="document.getElementById('modal_popup_details').style.visibility = 'hidden'"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.invoiceDetails" class="d-flex flex-column">
          <div class="d-flex flex-row justify-content-between">
            <p >
              <strong>{{ $t("finance.invoiceReferenceLabel") }} : &nbsp;&nbsp;</strong>
              <span>            
              <span>{{ this.invoiceDetails.reference }} </span>
              </span>
            </p>
            <p >
              <strong>{{ $t("finance.invoiceNumberLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ this.invoiceDetails.invoice }} </span>
            </p>
            <p >
              <strong>{{ $t("finance.invoiceAmountLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ this.invoiceDetails.amount }}</span>
            </p>
            <p >
              <strong>{{ $t("finance.mandateStatusLabel") }} : &nbsp;&nbsp;</strong>
              <span>
              {{ $t('finance.invoiceStatus_' + this.invoiceDetails.status) }}
              </span>
            </p>
          </div>
          <br />
          <div class="d-flex flex-row justify-content-between">
            <p >
              <strong>{{ $t("finance.customerTypeLabel") }} : &nbsp;&nbsp;</strong>
              <span>            
                      {{ $t('finance.companyType_' + this.invoiceDetails.customer.type) }}
              </span>
            </p>
            <p >
              <strong>{{ $t("finance.productLabel") }} : &nbsp;&nbsp;</strong>
              <span>
                        {{ $t('finance.product_' + this.invoiceDetails.customer.product) }}
               </span>
            </p>
            <p >
              <strong>{{ $t("finance.customerIdentifierLabel") }} : &nbsp;&nbsp;</strong>
              <span>   
                {{ this.invoiceDetails.customer.identifier }}
              </span>
            </p>
            <p >
              <strong>{{ $t("finance.companyNameLabel") }} : &nbsp;&nbsp;</strong>
              <span>
                {{ this.invoiceDetails.customer.name }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import moment from "moment";
  import httpServiceFinance from "@/http/http-finance.js";
  import Cookies from "js-cookie";

  export default {
    name: "InvoicesTable",
    props: {
      invoices: Array,
      msg: String,
    },
    data() {
      return {
        invoiceDetails: null,

      };
    },
    methods: {
      getInvoiceDetails(selectedInvoice) {
        // this.invoiceDetails =
        // {
        //   "id": 33,
        //   "product": 11,
        //   "reference": "DD20260601001",
        //   "invoice": 6811380367,
        //   "amount": 139747.37,
        //   "status": "P",
        //   "created": 1780775433166,
        //   customer: {
        //     "id": 100,
        //     "type": "CL",
        //     "product": 11,
        //     "identifier": 1,
        //     "name": "UP ROMANIA SRL"
        //   }
        // }
        // this.showModalPopup("modal_popup_details", true);

        // return;
        this.invoiceDetails = null;

        this.showModalPopup("modal_popup_loading", true);
        httpServiceFinance.financeService
          .getClientInvoiceDetails(
            selectedInvoice.id,
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              this.invoiceDetails = response.data;
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_details", true);
            } else if (response.status == 400 || response.status == 403) {
              this.invoiceDetails = null;
            }
          });
      },
      displayDateTimestamp(timestamp) {
        return moment(timestamp).format(
          "DD/MM/YYYY"
        );
      },
    },
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>

<style scoped>
  #modal_popup_details .modal-popup-content {
    text-align: left !important;
    max-width: 60% !important;
    width: 60%;
  }

  .invoices-table {
    padding: 1px;
  }

  .overflow {
    overflow-wrap: break-word;
  }

  .max-width-230 {
    max-width: 230px;
  }

  p {
    margin: 5px !important;
  }

  .border-top {
    border-top: 1px solid grey;
    margin-top: 15px;
  }

  .hover-table tr.trhover:hover a,
  .hover-table tr.trhover:hover a:hover {
    color: #fff;
  }

</style>
<style scoped src="@/assets/styles/beneficiary.css"></style>
